import { render, staticRenderFns } from "./ToApproveList.vue?vue&type=template&id=1ed638fe&lang=pug"
import script from "./ToApproveList.vue?vue&type=script&lang=js"
export * from "./ToApproveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports